import React from "react";
import { Archive } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function SessionArchivedBadge() {
  const { t } = useTranslation();
  return (
    <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-muted-surface px-2 py-0.5 text-xs font-normal text-text-mid">
      <Archive size={12} aria-hidden="true" />
      {t("recording_archived")}
    </span>
  );
}
